import React from "react";
import RowMenu from "../../crmpostventa-shared/components/RowMenu";

// Copy shown on controls the current user cannot use (usuarioActual.puedeGestionar is false).
export const NO_MANAGE_TITLE = "Tu usuario solo puede ver las gestiones de rollo";

/**
 * Last column of a row (or foot of a mobile card). Activas: "Gestionar" plus the row menu. Finalizadas: only
 * "Ver detalle" (design RowMenu: closed gestiones have no menu).
 */
export default function RowActions({
  item,
  card = false,
  finalizada,
  busy = false,
  canManage = true,
  onGestionar,
  onVerDetalle,
  menu,
}) {
  const className = card ? "crm-rollo__card-actions" : "crm-rollo__actions";

  if (finalizada) {
    return (
      <div className={className}>
        <button
          type="button"
          className="crm-rollo__btn crm-rollo__btn--secondary crm-rollo__btn--sm"
          disabled={!onVerDetalle}
          onClick={() => onVerDetalle?.(item)}
        >
          Ver detalle
        </button>
      </div>
    );
  }

  return (
    <div className={className}>
      <button
        type="button"
        className="crm-rollo__btn crm-rollo__btn--secondary crm-rollo__btn--sm"
        disabled={!onGestionar || busy || !canManage}
        title={!canManage ? NO_MANAGE_TITLE : undefined}
        onClick={() => onGestionar?.(item)}
      >
        Gestionar
      </button>
      <RowMenu {...menu} />
    </div>
  );
}
